// hooks/useClickOutside.ts
import React, { Dispatch, SetStateAction, useEffect } from "react";
import { CLICK_OUTSIDE_SET_TIMEOUT_DURATION } from "../utils";

type useClickOutsideProps = {
  ref: React.MutableRefObject<HTMLDivElement | null>;
  excludedRef?: React.MutableRefObject<HTMLDivElement | null>;
  setState: Dispatch<SetStateAction<boolean>> | ((state: boolean) => void);
  enablesetState?: boolean;
};
const useClickOutside = ({
  ref,
  setState,
  excludedRef,
  enablesetState = true,
}: useClickOutsideProps) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const element = ref.current;
      if (!element) return;
      const isClickedWithinElement = element.contains(event.target as Node);
      if (isClickedWithinElement) return;

      if (excludedRef?.current) {
        const isExcludedTarget = excludedRef?.current.contains(
          event.target as Node
        );
        if (isExcludedTarget) return;
      }

      if (!enablesetState) return;

      setTimeout(() => setState(false), CLICK_OUTSIDE_SET_TIMEOUT_DURATION);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setState, enablesetState, excludedRef]);
};

export { useClickOutside };
